"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLaybyProduct = void 0;
var LAYBUY = "laybuy";
var isLaybyProduct = function (product) {
    if (!product || !product.attributes || !Array.isArray(product.attributes)) {
        return false;
    }
    var laybyOption = product.attributes.find(function (attribute) { return attribute.name.toLowerCase() === LAYBUY && attribute.default_value === true && attribute.type.toLowerCase() === "boolean"; });
    if (!laybyOption)
        return false;
    return true;
};
exports.isLaybyProduct = isLaybyProduct;
